export default function (message) {
  return {
    type: 'NOTIFICATION',
    message,
  }
}